import React from 'react';

export default function BookmarkIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      viewBox="0 0 46 57"
      fill="none"
    >
      <mask id="path-1-inside-1_215_1004" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.0333 11.4H28.2V9.58333C28.2 6.49974 25.7003 4 22.6167 4C19.5331 4 17.0333 6.49974 17.0333 9.58333V11.4ZM13.0333 11.4H5C2.23858 11.4 0 13.6386 0 16.4V52C0 54.7614 2.23858 57 5 57H41C43.7614 57 46 54.7614 46 52V16.4C46 13.6386 43.7614 11.4 41 11.4H32.2V9.58333C32.2 4.29061 27.9094 0 22.6167 0C17.3239 0 13.0333 4.2906 13.0333 9.58333V11.4Z"
        />
      </mask>
      <path
        d="M17.0333 11.4H13.0333V15.4H17.0333V11.4ZM28.2 11.4V15.4H32.2V11.4H28.2ZM13.0333 11.4V15.4H17.0333V11.4H13.0333ZM32.2 11.4H28.2V15.4H32.2V11.4ZM17.0333 15.4H28.2V7.4H17.0333V15.4ZM32.2 11.4V9.58333H24.2V11.4H32.2ZM32.2 9.58333C32.2 4.29061 27.9094 0 22.6167 0V8C23.4911 8 24.2 8.70888 24.2 9.58333H32.2ZM22.6167 0C17.3239 0 13.0333 4.2906 13.0333 9.58333H21.0333C21.0333 8.70888 21.7422 8 22.6167 8V0ZM13.0333 9.58333V11.4H21.0333V9.58333H13.0333ZM5 15.4H13.0333V7.4H5V15.4ZM4 16.4C4 15.8477 4.44772 15.4 5 15.4V7.4C0.0294352 7.4 -4 11.4294 -4 16.4H4ZM4 52V16.4H-4V52H4ZM5 53C4.44772 53 4 52.5523 4 52H-4C-4 56.9706 0.0294319 61 5 61V53ZM41 53H5V61H41V53ZM42 52C42 52.5523 41.5523 53 41 53V61C45.9706 61 50 56.9706 50 52H42ZM42 16.4V52H50V16.4H42ZM41 15.4C41.5523 15.4 42 15.8477 42 16.4H50C50 11.4294 45.9706 7.4 41 7.4V15.4ZM32.2 15.4H41V7.4H32.2V15.4ZM36.2 11.4V9.58333H28.2V11.4H36.2ZM36.2 9.58333C36.2 2.08147 30.1185 -4 22.6167 -4V4C25.7003 4 28.2 6.49974 28.2 9.58333H36.2ZM22.6167 -4C15.1148 -4 9.03333 2.08145 9.03333 9.58333H17.0333C17.0333 6.49974 19.5331 4 22.6167 4V-4ZM9.03333 9.58333V11.4H17.0333V9.58333H9.03333Z"
        fill="black"
        mask="url(#path-1-inside-1_215_1004)"
      />
    </svg>
  );
}
